export default "__VITE_ASSET__CFjxXk4n__"